var ENCOUNTER_TYPE_LABELS = {
  appointment: "Appointment",
  admission: "Admission",
  "follow-up": "Follow-up",
  imaging: "Imaging",
  outpatient: "Outpatient",
  inpatient: "Inpatient",
  emergency: "Emergency",
  travel: "Travel"
};
var LAB_CATEGORIES = new Set(["laboratory", "lab"]);

/** Maps a raw encounter type to a friendly label, defaulting to 'Appointment'. */
export function getEncounterTypeLabel(encounterType) {
  var _ENCOUNTER_TYPE_LABEL;
  if (!encounterType) return "Appointment";
  return (_ENCOUNTER_TYPE_LABEL = ENCOUNTER_TYPE_LABELS[encounterType.toLowerCase()]) !== null && _ENCOUNTER_TYPE_LABEL !== void 0 ? _ENCOUNTER_TYPE_LABEL : encounterType;
}

/** Extracts the viewable documents attached to an encounter. */
export function getEncounterDocuments(encounter) {
  var _encounter$service_re;
  var documents = [];
  var documentReference = encounter.document_reference;
  if (documentReference !== null && documentReference !== void 0 && documentReference.binary) {
    documents.push({
      name: documentReference.type_text || "Document Reference",
      sourceType: "document_reference",
      binary: documentReference.binary,
      resourceType: documentReference.resource_type,
      resourceId: documentReference.fhir_id
    });
  }
  ((_encounter$service_re = encounter.service_requests) !== null && _encounter$service_re !== void 0 ? _encounter$service_re : []).forEach(function (serviceRequest) {
    var report = serviceRequest.diagnostic_report;
    if (report !== null && report !== void 0 && report.binary && report.code_text) {
      documents.push({
        name: report.code_text,
        sourceType: "diagnostic_report",
        binary: report.binary,
        resourceType: report.resource_type,
        resourceId: report.fhir_id
      });
    }
  });
  return documents;
}

/** Counts all documents associated with an encounter. */
export function getEncounterDocumentCount(encounter) {
  var _encounter$diagnostic, _encounter$service_re2;
  var count = 0;
  if (encounter.document_reference) count += 1;
  if ((_encounter$diagnostic = encounter.diagnostic_report) !== null && _encounter$diagnostic !== void 0 && _encounter$diagnostic.binary) count += 1;
  ((_encounter$service_re2 = encounter.service_requests) !== null && _encounter$service_re2 !== void 0 ? _encounter$service_re2 : []).forEach(function (serviceRequest) {
    if (serviceRequest.binary) count += 1;
  });
  return count;
}

/** Extracts the ordered laboratory test names from an encounter. */
export function getEncounterLabs(encounter) {
  var _encounter$service_re3;
  return ((_encounter$service_re3 = encounter.service_requests) !== null && _encounter$service_re3 !== void 0 ? _encounter$service_re3 : []).filter(function (serviceRequest) {
    var _serviceRequest$categ;
    return LAB_CATEGORIES.has(((_serviceRequest$categ = serviceRequest.category_text) !== null && _serviceRequest$categ !== void 0 ? _serviceRequest$categ : "").toLowerCase());
  }).map(function (serviceRequest) {
    return serviceRequest.code_text;
  }).filter(function (codeText) {
    return Boolean(codeText);
  });
}